export default __webpack_public_path__ + "static/media/Q4_4_resized.f6f67d94.jpg";